import React from 'react';
import { useParams } from 'react-router-dom';
import ErrorMessage from '../../components/ErrorMessage';
import LoadingIndicator from '../../components/LoadingIndicator';
import useCurriculum from '../../hooks/useCurriculum';
import { useUser } from '../authentication';
import { HeaderNavigation } from './components/HeaderNavigation';
import { OverviewContentPresenter } from './components/OverviewContentPresenter';
import { useOverviewContent } from './hooks/useOverviewContent';

export const CurriculumOverview = () => {
  const { user } = useUser();
  const { curriculumId } = useParams<{ curriculumId: string }>();
  const { brand, ageCategory } = useCurriculum();
  const { isLoading, error, pages } = useOverviewContent(brand.code, ageCategory, curriculumId);
  const crumbs = [
    { name: 'Curriculum', route: '#/bible-studies' },
    {
      name: `${brand.name}: ${ageCategory}`,
    },
  ];

  return (
    <>
      <HeaderNavigation
        crumbs={crumbs}
        brandCode={brand.code}
        ageCategory={ageCategory}
        curriculumId={curriculumId}
        orgId={user?.lastSelectedAccount}
        activeTab="overview"
      />

      {isLoading && <LoadingIndicator />}
      {!isLoading && error && <ErrorMessage />}
      {!isLoading && !error && (
        <OverviewContentPresenter
          brandCode={brand.code}
          ageCategory={ageCategory}
          curriculumId={curriculumId}
          pages={pages}
        />
      )}
    </>
  );
};
